import { useEffect, useCallback } from 'react'
import { useEventQueue } from './event-queue'
import { useTrackingsActions } from '../hooks/trackings'
import { shallow } from 'zustand/shallow'

export const useTrackingCoreWebVitalEvents = () => {
	const { coreWebVitals: trackingCoreWebVitals } = useTrackingsActions()

	const eventQueue = useEventQueue(
		useCallback((state) => state.eventQueue, []),
		shallow
	)

	useEffect(() => {
		const runTrackingCoreWebVitals = async () => {
			for (const event of eventQueue) {
				if (!useEventQueue.getState().eventProcessed.has(event.id)) {
					const result = await trackingCoreWebVitals(event)
					if (result) {
						useEventQueue.getState().eventProcessed.add(event.id)
					}
				}
			}
			useEventQueue.getState().clearProcessed()
		}

		runTrackingCoreWebVitals()
	}, [trackingCoreWebVitals, eventQueue])
}
